import { Route, Routes } from 'react-router-dom';
import { useMount } from 'react-use';

import { useAppDispatch } from 'utils/redux/useAppDispatch';

import { analyticsActions } from '../../analytics.actions';

import { IntelligenceRemoteView } from './views/remote/intelligenceRemote.view';

export const IntelligenceView = (): JSX.Element => {
  const dispatch = useAppDispatch();

  useMount(() => {
    dispatch(analyticsActions.setMeta({ meta: { tier: 'insights' } }));
  });

  return (
    <Routes>
      <Route path="*" element={<IntelligenceRemoteView />} />
    </Routes>
  );
};
